import React, { useState } from 'react';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import 'dayjs/locale/ko';
import SearchCodeSelectbox from '../common/form/selectbox/SearchCodeSelectbox';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as dayjs from 'dayjs';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

// 기술지원 관리(/techmng) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
export const ProjectListBox = ({ formik, onReset }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <SearchCard
      summary={searchSummary(formik.values)}
      onSubmit={formik.handleSubmit}
      onReset={onReset}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"impt" "keyword" "search" "period" "btns"`,
          sm: `"impt keyword" "search period" "btns btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(160px, 1fr) minmax(160px, 1fr)',
        },
        '@media (min-width:1440px)': {
          gridTemplateAreas: `"impt keyword search period btns"`,
          gridTemplateColumns:
            'minmax(140px, 0.6fr) minmax(140px, 0.6fr) minmax(160px, 1fr) minmax(280px, 1.1fr) 190px',
        },
      }}
    >
      {/* 프로젝트 중요도 */}
      <Box sx={{ gridArea: 'impt', minWidth: 0 }}>
        <SearchCodeSelectbox
          formik={formik}
          variant="outlined"
          size="small"
          name="searchPrjImpt"
          label="프로젝트 중요도"
          required={false}
          filterObject={{
            blcCd: 'BASE',
            mlcCd: 'FORCAST',
            slcCd: 'PRJ_IMPT',
          }}
        />
      </Box>

      {/* 검색키워드 */}
      <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required={false}
          id="searchKeyword"
          name="searchKeyword"
          label="검색키워드"
          value={formik.values.searchKeyword}
          onChange={formik.handleChange}
          error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
          helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
        >
          <MenuItem value="prjNo">프로젝트 번호</MenuItem>
          <MenuItem value="cstNm">사업명</MenuItem>
          <MenuItem value="partnerNm">고객명</MenuItem>
          <MenuItem value="cmpStatus">상태</MenuItem>
        </TextField>
      </Box>

      {/* 검색어 */}
      <Box sx={{ gridArea: 'search', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          fullWidth
          required={false}
          id="searchWords"
          name="searchWords"
          label="검색어"
          value={formik.values.searchWords || ''}
          onChange={formik.handleChange}
          error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
          helperText={formik.touched.searchWords && formik.errors.searchWords}
          InputProps={{
            endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
          }}
        />
      </Box>

      {/* 등록 시작~종료일 */}
      <Box sx={{ gridArea: 'period', minWidth: 0 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
            <DatePicker
              label="등록 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchStrtDt"
              name="searchStrtDt"
              value={searchStrtDt}
              onChange={(newValue) => {
                setSearchStrtDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchStrtDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 130px' },
                  error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                  helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                },
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
              ~
            </Typography>
            <DatePicker
              label="등록 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchEndDt"
              name="searchEndDt"
              value={searchEndDt}
              onChange={(newValue) => {
                setSearchEndDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchEndDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 130px' },
                  error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                  helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                },
              }}
            />
          </Box>
        </LocalizationProvider>
      </Box>
    </SearchCard>
  );
};
